<template>
  <div class="class-student">
    <el-transfer
      class="btn-list"
      filterable
      filter-placeholder="请输入学生姓名"
      v-model="selectStudentList"
      :data="classStudentList"
      :props="{
        key: 'studentId',
        label: 'studentName',
      }"
      :titles="['未选择', '已选择']"
    ></el-transfer>
    <div class="btn-list">
      <el-button type="primary" plain @click="back">返回</el-button>
      <el-button type="primary" @click="classStudentSubmit">确认</el-button>
    </div>
  </div>
</template>

<script>
export default {
  props: ["isChooseContainerShow", "gradeStudentList", "classStudentList", "comparativeExamData"],
  data() {
    return {
      selectStudentList: [],
      // filterMethod(query, item) {
      //   return gradeStudentList.indexOf(query) > -1;
      // },
    };
  },
  methods: {
    // 选择班级学生成绩对比点击提交
    classStudentSubmit() {
      const comparativeExamArray = this.comparativeExamData.map(
        (item) => item.id
      );
      let data = {
        // oneExamInfoId: this.comparativeExamData[0].id,
        // twoExamInfoId: this.comparativeExamData[1].id,
        examInfoIds: comparativeExamArray,
        studentIds: this.selectStudentList,
        gradeId: this.gradeStudentList[0].gradeId 
      };
      // console.log("data:", data);
      this.$emit("classStudentSubmit", data);
    },
    // 返回选择方式
    back() {
      this.selectStudentList = [];
      this.$emit("update:isChooseContainerShow", true);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./classStudent.scss";
</style>